import { areLinkedTasksEnabled } from '~src/linkedTasks/utils/LinkedTaskHelpers';

import { ModalInstance, ReactModalService } from '../../commonInfra/dialogs/ReactModalService';
import { FlowBaseInfo } from '../../ts/models/FlowInfo';
import { RunFlowTaskInfo } from '../../ts/models/RunFlowTaskInfo';
import { editFlowRunSchedulesDialog, getFlowRunSchedulesDialog } from '../components/FlowRunSchedulesDialog';
import { getFlowTaskDialog } from '../components/FlowTaskDialog';

export function openCreateFlowRunTaskDialog(flowInfo: FlowBaseInfo, outputId?: string): Promise<any> {
  let modalInstance: ModalInstance;
  const dismiss = () => modalInstance.dismiss();
  const dialog = areLinkedTasksEnabled() ?
    getFlowTaskDialog(flowInfo, dismiss, outputId) :
    getFlowRunSchedulesDialog(flowInfo, dismiss, outputId);
  modalInstance = ReactModalService.open(dialog);
  return modalInstance.result.catch(reason => {});
}

export function editFlowRunTaskDialog(flowTask: RunFlowTaskInfo): Promise<any> {
  let modalInstance: ModalInstance;
  const dismiss = () => modalInstance.dismiss();
  const dialog = editFlowRunSchedulesDialog(flowTask, dismiss);
  modalInstance = ReactModalService.open(dialog);
  return modalInstance.result.catch(reason => {});
}
